import React from "react";
import StaffMember from "../../containers/staffMember/staffMember";
import Title from '../../containers/title/title';
import classes from "./staffSection.module.css";
import staff1 from "../../../assets/images/Stephanie-Alnaber 1.png";

const StaffSection = (props) => {
  return (
    <section className={classes.staffSection}>
      <Title title={parseInt(localStorage.getItem('language')) === 1 
        ? "ACADEMY STAFF" 
        : "طاقم الأكاديمية"} 
      />
      <div className={classes.staffGrid}>
        {props.staff?.map((member) => (
          <StaffMember key={member.id} {...member} />
        ))}
      </div>
    </section>
  );
}

export default StaffSection;
